import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const SalesOperatingHours = ({ data }) => {
  const operatingHours = data?.operatingHours;
  if (!operatingHours) return null;
  return (
    <>
      {operatingHours.length > 0 && (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Typography variant="h6" align="center" sx={{ mt: 2 }}>
            Daily Operating Hours
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Open Time</TableCell>
                <TableCell>Close Time</TableCell>
                <TableCell align="right">Operating Hours</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {operatingHours.map((row) => (
                <TableRow key={row.date}>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.openTime}</TableCell>
                  <TableCell>{row.closeTime}</TableCell>
                  <TableCell align="right">{row.operatingHours} hrs</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default SalesOperatingHours;
